<app-header hasLogo="true"></app-header>

<div id="portal">
<p style="display: none;">portal works!</p>

    <nav class="tabbox">

        <mat-tab-group (selectedTabChange)="share.selectedtab = $event.index; setActiveTab($event.index)" class="tabcontainer">
            
            <mat-tab class="txtcolor" style="color:#fff;" [label]="'Portal.Menu.Logo' | translate"> </mat-tab>
            <mat-tab class="txtcolor" style="color:#fff;" [label]="'Portal.Menu.Goods' | translate"> </mat-tab>
            <mat-tab class="txtcolor" style="color:#fff;" [label]="'Portal.Menu.Images' | translate"> </mat-tab>
            <mat-tab class="txtcolor" style="color:#fff;" [label]="'Portal.Menu.Social' | translate"> </mat-tab>

        </mat-tab-group>
        
        <div class="tabcontent" style="background: #faebd70d;">
            <app-logo *ngIf="share.selectedtab === 0 || share.selectedtab === null"></app-logo>
            <app-goods *ngIf="share.selectedtab === 1"></app-goods>
            <app-slider *ngIf="share.selectedtab === 2"></app-slider>
            <app-social *ngIf="share.selectedtab === 3"></app-social>
        </div>
    </nav>
    <div id="c" class="compress" *ngIf="cLink">
        <a [href]="cWebsite" target="_blank" rel="noopener noreferrer">
            <span>فشرده ساز</span>
        </a>
    </div>

</div>